module.exports = __webpack_public_path__ + "static/media/login_full_bg6.7dcfb8ba.jpg";